import Space from '@/components/Space';
import {
  ConnectedAccountBox,
  ConnectedAccountInfo,
  ConnectedAccountWrapper,
} from '../styled-components';
import UserAvatar from '@/components/UserAvatar';
import { useEffect, useState } from 'react';
import { type UserSummary } from '@/lib/types';
import AccountInfoLoadingMessage from '../utils/AccountInfoLoadingMessage';
import NoAccountConnectedMessage from '../utils/NoAccountConnectedMessage';
import googleAccessTokenStore from '../../utils/google/googleAccessTokenStore';
import GoogleDriveIcon from '../../utils/icons/GoogleDriveIcon';
import getGoogleAccountInfo from './getGoogleAccountInfo';
import DisconnectAccountButton from '../utils/DisconnectAccountButton';
import { FormattedMessage } from 'react-intl';

const GoogleAccountSettings = () => {
  const [loading, setLoading] = useState(true);
  const [accountInfo, setAccountInfo] = useState<UserSummary | null>(null);

  useEffect(() => {
    const getAccountInfo = async (): Promise<void> => {
      const accountInfo = await getGoogleAccountInfo();

      setAccountInfo(accountInfo);
      setLoading(false);
    };

    getAccountInfo();
  }, []);

  const disconnectAccount = async (): Promise<void> => {
    googleAccessTokenStore.clearAccessToken();

    setAccountInfo(null);
  };

  return (
    <ConnectedAccountWrapper>
      <h3>
        <GoogleDriveIcon />
        <Space width={8} />
        <FormattedMessage id="portfolio.challenge.files.add.connected_accounts_dialog.google_account_settings.title" />
      </h3>
      <ConnectedAccountBox>
        {loading ? (
          <AccountInfoLoadingMessage />
        ) : accountInfo === null ? (
          <NoAccountConnectedMessage variant="google" />
        ) : (
          <>
            <div>
              <UserAvatar user={accountInfo} size={36} marginRight={12} />
              <ConnectedAccountInfo>
                <h4>{accountInfo.name}</h4>
                <p>{accountInfo.email}</p>
              </ConnectedAccountInfo>
            </div>
            <DisconnectAccountButton onClick={disconnectAccount} />
          </>
        )}
      </ConnectedAccountBox>
    </ConnectedAccountWrapper>
  );
};

export default GoogleAccountSettings;
